/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/landing/components/Features.tsx
 * PURPOSE: Features section - 4-card grid showcasing platform capabilities
 * SDLC FRAMEWORK VERSION: 6.1.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * DATE: 2025-12-28
 * COMPLIANCE: SDLC 6.3.1 + NQH Brand Design System V2.0
 *
 * @cross-references
 * - Design: docs/02-design/04-ui-ux-design/LOGIN-LANDING-REDESIGN-DESIGN.md
 */

import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Features.module.css";

interface FeatureCard {
  icon: string;
  titleKey: string;
  descKey: string;
}

const features: FeatureCard[] = [
  {
    icon: "📍",
    titleKey: "landing.features.gps.title",
    descKey: "landing.features.gps.desc",
  },
  {
    icon: "📅",
    titleKey: "landing.features.scheduling.title",
    descKey: "landing.features.scheduling.desc",
  },
  {
    icon: "🏥",
    titleKey: "landing.features.bhxh.title",
    descKey: "landing.features.bhxh.desc",
  },
  {
    icon: "📊",
    titleKey: "landing.features.analytics.title",
    descKey: "landing.features.analytics.desc",
  },
];

export const Features: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.features}>
      <h2 className={styles.title}>{t("landing.features.title")}</h2>

      <div className={styles.grid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.icon}>{feature.icon}</div>
            <h3 className={styles.cardTitle}>{t(feature.titleKey)}</h3>
            <p className={styles.cardDesc}>{t(feature.descKey)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
